import { initReactI18next } from 'react-i18next';

import i18n from 'i18next';
import Backend from 'i18next-http-backend';

import { getLocale, Language } from 'src/models/Language.model';

const i18nUI = i18n.createInstance();

const lng = getLocale(Language.ENGLISH).code;

i18nUI
  .use(Backend)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en-US',
    debug: import.meta.env.MODE !== 'production',
    ns: ['common', 'pages'],
    lng,
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: '/locales/UI/{{lng}}/{{ns}}.json',
    },
    load: 'currentOnly',
  });

export default i18nUI;
